<template>
  <div>
    <v-row>
      <v-col>
        <text-field
          v-model="formData.email"
          :field="{
            key: 'email',
            label: 'Email'
          }"
          :validation-errors="validationErrors"
          @clear-validation-errors="$emit('clear-validation-errors', 'email')"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <text-field
          v-model="formData.message"
          :field="{
            key: 'message',
            label: $t('fleet/vehicle/documents_tab.email_text')
          }"
          :validation-errors="validationErrors"
          @clear-validation-errors="$emit('clear-validation-errors', 'message')"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TextField from '@/global/components/fields/TextField.vue'

export default {
  name: 'SendDocumentOnEmail',

  components: {
    TextField
  },

  props: {
    validationErrors: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      formData: {}
    }
  },

  watch: {
    formData: {
      immediate: true,
      deep: true,
      handler (val) {
        this.$emit('update-data', val)
      }
    }
  },

  created () {
    // clear form data every time when dialog is opened
    this.formData = {}
    this.$emit('remove-all-validation-errors')
  }
}
</script>

<style scoped>
</style>
